import { useContext, useEffect, useState } from "react";
import { DrawerContext } from "@CONTEXTS";
import UserDetail from "./detail";

const useTabs = () => {
  const { data } = useContext(DrawerContext);
  const [state, setState] = useState([]);

  useEffect(() => {
    const tabs = [
      {
        title: "Kullanıcı Detayı",
        component: <UserDetail />,
      },
    ];

    setState(tabs);
  }, [data]);

  return state;
};

export default useTabs;
